/** D4: opt-in page padding. 'default' is the pre-existing admiral padding. */ export const PADDING = {
    default: 'p-4 sm:p-6',
    page: 'px-4 pt-6 pb-8 md:px-[var(--component-page-padding-x)] md:pt-[var(--component-page-padding-top)] md:pb-[var(--component-page-padding-bottom)]'
};
